import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as headerConsts from '@shared-constants/header-constants';

import { environment } from '../../environments/environment';
import { LogRocketService } from '../services/log-rocket.service';

@Injectable()
export class SetLoggingHeadersInterceptor implements HttpInterceptor {
  private readonly logRocketService = inject(LogRocketService);

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.startsWith(environment.webServerUrl)) {
      //Only send the headers to our webserver
      const modifiedReq = request.clone({
        headers: new HttpHeaders()
          .set(headerConsts.HEADER_LOGGING_EMPLOYEE_NUMBER, this.logRocketService.userId)
          .set(headerConsts.HEADER_LOGGING_LOG_ROCKET_URL, this.logRocketService.url)
          .set(headerConsts.HEADER_LOGGING_APPLICATION_NAME, environment.application),
      });
      return next.handle(modifiedReq);
    } else {
      //All other request methods or requests to "external" URLs just get passed through
      return next.handle(request);
    }
  }
}
